import { Popover, Textarea, Button, Group, Text, Stack, ActionIcon, Divider } from "@mantine/core"
import { useForm } from "@mantine/form"
import { useState } from "react"
import { IconX } from "@tabler/icons-react"

const PopOverCustomButton = ({
    name,
    label,
    placeholder,
    callback,
    loading = false,
    withinPortal = false,
    focusColor = "blue",
    children,
    initialValues = { reason: "" },
    confirmLabel = "Confirm",
    disabled = false,
    disableConfirm = false,
    validate = { reason: (v) => v.trim().length < 2 ? "Please enter a reason" : null },
    transformValues = (values) => values,
    ...props
}) => {
    const borderColor = focusColor ? `var(--mantine-color-${focusColor}-6)` : 'var(--mantine-primary-color-filled)';
    const glowColor = focusColor ? `var(--mantine-color-${focusColor}-3)` : 'var(--mantine-primary-color-filled)';
    const [opened, setOpened] = useState(false)

    const form = useForm({
        mode: "uncontrolled",
        initialValues,
        validate,
        transformValues,
    })

    const handleClose = () => {
        setOpened(false)
        form.reset()
    }

    const handleSubmit = (values) => {
        setOpened(false)
        form.reset()
        callback(values)
    }

    return (
        <Popover
            width={320}
            position="bottom-end"
            withArrow
            arrowSize={10}
            shadow="lg"
            radius="md"
            opened={opened}
            onClose={handleClose}
            withinPortal={withinPortal}
            trapFocus
        >
            <Popover.Target>
                <Button
                    disabled={disabled}
                    loading={loading}
                    onClick={() => setOpened((o) => !o)}
                    {...props}
                >
                    {name}
                </Button>
            </Popover.Target>

            <Popover.Dropdown p={0} style={{ overflow: "hidden", background: "var(--mantine-color-body)", border: `1.5px solid ${borderColor}`, boxShadow: `0 0 0 3px color-mix(in srgb, ${glowColor} 30%, transparent), var(--mantine-shadow-xl)` }}>
                <Group justify="space-between" align="center" px="md" py="sm">
                    <Text size="sm" fw={600} >
                        {label ?? "Please provide a reason"}
                    </Text>
                    <ActionIcon
                        variant="subtle"
                        color="gray"
                        size="sm"
                        onClick={handleClose}
                        aria-label="Close"
                    >
                        <IconX size={14} />
                    </ActionIcon>
                </Group>

                <Divider />

                <form onSubmit={form.onSubmit(handleSubmit)}>
                    <Stack gap="sm" p="md">
                        {children ? children(form) : (
                            <Textarea
                                required
                                label="Reason"
                                placeholder={placeholder ?? "Add a note…"}
                                autosize
                                minRows={2}
                                maxRows={5}
                                key={form.key("reason")}
                                {...form.getInputProps("reason")}
                            />
                        )}
                        <Group justify="flex-end" gap="xs">
                            <Button
                                variant="subtle"
                                color="gray"
                                size="xs"
                                onClick={handleClose}
                                disabled={loading}
                            >
                                Cancel
                            </Button>
                            <Button
                                type="submit"
                                size="xs"
                                loading={loading}
                                color={props.color}
                                disabled={disableConfirm || loading}
                            >
                                {confirmLabel}
                            </Button>
                        </Group>
                    </Stack>
                </form>
            </Popover.Dropdown>
        </Popover>
    )
}

export default PopOverCustomButton